var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L6.5 6.5L12 1","stroke":"#011949","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowInline.defaultProps = {"width":"13","height":"8","viewBox":"0 0 13 8","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
